import { Injectable } from '@angular/core';
import { AppConfigurationClient, GetConfigurationSettingResponse } from '@azure/app-configuration';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  client: AppConfigurationClient;
  constructor(private configService: ConfigService) { 
    this.client = new AppConfigurationClient(this.configService.configuration.appConfigurationConnectionString);
  }

  async getFeatureFlag(featureName: string): Promise<boolean> {
    const featureFlagKey = `.appconfig.featureflag/${featureName}`;
    const options = { key: featureFlagKey };
    const flag: GetConfigurationSettingResponse = await this.client.getConfigurationSetting(options);
    return <boolean>JSON.parse(<string>flag.value).enabled;
  }
}
